import { Form } from 'factorial-form'

import type { PanesHeaderInlineInfoProps } from 'modules/core/components/PanesHeader'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { calculateRatingAverageScore } from 'modules/performance_process/lib/calculateRatingAverageScore'

const NORMALIZED_SCORE = 10

export const useScore = () => {
  const validValue = (value: undefined | null | string | number) => {
    if (!value || typeof value === 'number') {
      return true
    }

    if (typeof value === 'string') {
      return !!value.trim() ? !Number.isNaN(Number(value)) : false
    }

    return true
  }

  const selectRatingForms = (forms: Form[]) =>
    forms.filter((form) => {
      const value = form.get('value').value
      if (form.get('field_type').value == 'rating' && value && validValue(value)) {
        return form
      }
    })

  const calculateScore = (forms: Form[]): string | undefined => {
    const selectedForms = selectRatingForms(forms)

    const ratingValues = selectedForms.map((form) => ({
      value: form.get('value').value,
      maxScale: +form.get('max_value').value,
    }))
    const { formattedScore } = calculateRatingAverageScore(ratingValues)
    return formattedScore
  }

  const modifyScoreInlineInfo = (
    inlineInfo: PanesHeaderInlineInfoProps[],
    score: string | undefined
  ) => {
    const scoreInlineInfo = inlineInfo.find((info) => info.icon === 'calculator')

    if (!scoreInlineInfo) return
    if (!score) {
      return [
        {
          icon: 'calculator',
          message: i18n.t('surveys.answer.performance_score', { score: '-' }),
        },
      ]
    }

    const normalizedScore = `${score}/${NORMALIZED_SCORE}`

    scoreInlineInfo.message = i18n.t('surveys.answer.performance_score', {
      score: normalizedScore,
    })
    inlineInfo[inlineInfo.indexOf(scoreInlineInfo)] = scoreInlineInfo
  }

  const buildInlineInfo = (score: string | undefined): PanesHeaderInlineInfoProps[] => {
    if (!hasFeature('reviews_weighted_average')) return []
    const normalizedScore = `${score}/${NORMALIZED_SCORE}`

    if (!score) {
      return [
        {
          icon: 'calculator',
          message: i18n.t('surveys.answer.performance_score', { score: '-' }),
        },
      ]
    }

    return [
      {
        icon: 'calculator',
        message: i18n.t('surveys.answer.performance_score', { score: normalizedScore }),
      },
    ]
  }

  return {
    calculateScore,
    modifyScoreInlineInfo,
    buildInlineInfo,
  }
}
